import axios from "../axios";

class HelperService {

    getLivingCircumstances() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/living-circumstances';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getWorkingCircumstances() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/working-circumstances';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getBuyingInterestPeriods() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/buying-interest-periods';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getBestTimeToContact() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/best-time-to-contact';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getMaritalStatuses() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/marital-statuses';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getOwnershipStatuses() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/home-ownership-statuses';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getNationalityChoices() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/nationalities';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getEthnicityChoices() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/ethnicities';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getReligionChoices() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/religions';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getSexualityChoices() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/sexualities';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getGenderChoices() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/genders';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getRelationshipStatusChoices() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/relationship-statuses';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getLocalAuthorities() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/local-authorities';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getCounties() {
        return new Promise(function(resolve, reject) {
            let url = 'lists/counties';
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

    getLocalAuthorityFromPostcode(postcode) {
        return new Promise(function(resolve, reject) {
            let url = 'postcode/' + postcode;
            axios.get(url)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error)
                })
        });
    }

}

export default new HelperService();
